import ProvinceSummary from "./ProvinceSummary";
import MapChart from "./MapChart";
import BreadcrumbSearch from "../../common/BreadcrumbSearch";
import Tab from "../../common/Tab";
import CandidateSummary from "./CandidateSummary";
import AreaCards from "./AreaCards";
import TopPoliticalPartiesSection from "./TopPoliticalPartiesSection";
// import CountDown from "../Home/CountDown";
import HeavyWeight from "../PopularRegion/HeavyWeight";

const Global = (props) => {
  const { tab, fetched, provinces, data, dataPR, parties } = props;

  const globalData = data || { provinces: [] };

  return (
    <>
      {/* <CountDown /> */}
      {/* <Tab tab={tab} handleTabChange={props.handleTabChange} /> */}
      <CandidateSummary data={globalData} parties={parties} />
      <MapChart tab={tab} fetched={fetched} provinces={provinces} parties={parties} data={globalData} dataPR={dataPR} handleSearch={props.handleSearch} />
      <HeavyWeight tab={tab} fetched={fetched} showtab={false} showmore={true} searchParam={props.searchParam} provinces={provinces} parties={parties} data={data} handleTabChange={props.handleTabChange} handleSearch={props.handleSearch} />
      <TopPoliticalPartiesSection />
      <BreadcrumbSearch tab={tab} showSearch={true} searchParam={props.searchParam} provinces={provinces} handleSearch={props.handleSearch} />
      <AreaCards tab={tab} fetched={fetched} data={globalData} parties={parties} searchParam={props.searchParam} />
      {/* <ProvinceSummary tab={tab} fetched={fetched} provinces={provinces} parties={parties} data={globalData.provinces} dataPR={dataPR} /> */}
    </>
  );
};

export default Global;
